module.exports = __webpack_public_path__ + "img/apple-icon-72x72.99126da6.png";